import axios from '@/services/axiosConfig'

const endPoint = {
	lookupTags: instId => `/institute/${instId}/tag/all`,
	createTags: instId => `/institute/${instId}/tag`,
	lookupSearchTags: instId => `/institute/${instId}/tag/list`,
	deleteTag: instId => `/institute/${instId}/tag`,
}

const TagAPI = {
	lookupTags: instId => axios.get(endPoint.lookupTags(instId)),
	createTags: (instId, data) => axios.post(endPoint.createTags(instId), data),
	lookupSearchTags: instId => axios.get(endPoint.lookupSearchTags(instId)),
	deleteTag: (instId, params) =>
		axios.delete(endPoint.deleteTag(instId), { params }),
}

export default TagAPI
